import { LineSkeleton } from 'components/Skeleton/LineSkeleton'
import Styles from './CaptionSkeleton.module.scss'

export const CaptionSkeleton = () => (
  <div className={Styles.captionSkeleton}>
    <LineSkeleton className={Styles.skeletonLine} width="90%" />
    <LineSkeleton className={Styles.skeletonLine} width="90%" />
    <LineSkeleton className={Styles.skeletonLine} width="60%" />
  </div>
)
